export const initialState = {
  businessProduct: {},
  businessProducts: [],
  businessProductsLoading: false,
  businessProductNextTokens: { 1: null },
  businessProductsError: null,
  newProduct: "",
  newProductLoading: false,
  newProductError: null,
  productID: "",
  updateProductError: null,
  updateProductLoading: false,
  deleteProductError: null,
  deleteProductLoading: false,
  businessProductLoading: false,
  businessProductError: null,
  productCategories: [],
  productCategoriesLoading: false,
  productCategoriesError: null,
  productCategoryNextTokens: { 1: null },
  newCategory: "",
  newCategoryError: null,
  newCategoryLoading: false,

  updateCategoryError: null,
  updateCategoryLoading: false,
  adjustStockLedger: {},
  adjustStockLoading: false,
  adjustStockError: null,
  inventoryLedger: [],
  inventoryLedgerLoading: false,
  inventoryLedgerError: null,
  inventoryLedgerNextTokens: { 1: null },
  writeDownLoading: false,
  writeDownError: null,
  writeDownResult: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_LIST_BUSINESS_PRODUCT":
      return {
        ...state,
        request: action.payload.request,
        businessProducts: [],
        businessProductsLoading: true,
        businessProductsError: null,
        businessProductNextTokens:
          action.payload.page === 1
            ? initialState.businessProductNextTokens
            : state.businessProductNextTokens,
      };
    case "LIST_BUSINESS_PRODUCT_SUCCESS":
      return {
        ...state,
        request: null,
        businessProducts: action.payload.items,
        businessProductsLoading: false,
        businessProductNextTokens: {
          ...state.businessProductNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "LIST_BUSINESS_PRODUCT_ERROR":
      return {
        ...state,
        request: null,
        businessProductsLoading: false,
        businessProductsError: action.error,
      };
    case "REQUEST_GET_BUSINESS_PRODUCT":
      return {
        ...state,
        request: action.payload.request,
        businessProduct: {},
        businessProductLoading: true,
        businessProductError: null,
      };
    case "GET_BUSINESS_PRODUCT_SUCCESS":
      const updatedProducts = state.businessProducts.map((item) =>
        item.id === action.payload.product.id ? action.payload.product : item
      );
      return {
        ...state,
        businessProduct: action.payload.product,
        businessProducts: updatedProducts,
        businessProductLoading: false,
        request: null,
      };
    case "GET_BUSINESS_PRODUCT_ERROR":
      return {
        ...state,
        businessProductLoading: false,
        businessProductError: action.error,
        request: null,
      };
    case "REQUEST_CREATE_BUSINESS_PRODUCT":
      return {
        ...state,
        request: action.payload.request,
        newProduct: "",
        newProductError: null,
        newProductLoading: true,
      };
    case "SUCCESS_CREATE_BUSINESS_PRODUCT":
      return {
        ...state,
        request: null,
        newProduct: action.payload.product,
        businessProducts: [action.payload.product, ...state.businessProducts],
        newProductLoading: false,
      };
    case "ERROR_CREATE_BUSINESS_PRODUCT":
      return {
        ...state,
        request: null,
        newProductLoading: false,
        newProductError: action.error,
      };
    case "REQUEST_UPDATE_BUSINESS_PRODUCT":
      return {
        ...state,
        request: action.payload.request,
        productID: "",
        updateProductError: null,
        updateProductLoading: true,
      };
    case "UPDATE_BUSINESS_PRODUCT_SUCCESS":
      const { product } = action.payload;
      const updatedProductsUpdate = state.businessProducts.map(
        (businessProduct) =>
          businessProduct.id === product.id ? product : businessProduct
      );
      return {
        ...state,
        request: null,
        productID: product.id,
        updateProductLoading: false,
        updateProductError: null,
        businessProducts: updatedProductsUpdate,
      };
    case "ERROR_UPDATE_BUSINESS_PRODUCT":
      return {
        ...state,
        request: null,
        updateProductLoading: false,
        updateProductError: action.error,
      };
    case "REQUEST_DELETE_BUSINESS_PRODUCT":
      return {
        ...state,
        request: action.payload.request,
        deleteProductLoading: true,
        deleteProductError: null,
        deletedID: "",
      };
    case "DELETE_BUSINESS_PRODUCT_SUCCESS":
      return {
        ...state,
        request: null,
        businessProducts: state.businessProducts.filter(
          (product) => product.id !== action.payload.id
        ),
        deleteProductLoading: false,
        deleteProductError: null,
        deletedID: action.payload.id,
      };
    case "DELETE_BUSINESS_PRODUCT_ERROR":
      return {
        ...state,
        request: null,
        deleteProductLoading: false,
        deleteProductError: action.error,
      };
    case "REQUEST_LIST_PRODUCT_CATEGORIES":
      return {
        ...state,
        request: action.payload.request,
        productCategories: [],
        productCategoriesLoading: true,
        productCategoriesError: null,
        productCategoryNextTokens:
          action.payload.page === 1
            ? initialState.productCategoryNextTokens
            : state.productCategoryNextTokens,
      };
    case "LIST_PRODUCT_CATEGORIES_SUCCESS":
      return {
        ...state,
        request: null,
        productCategories: action.payload.items,
        productCategoriesLoading: false,
        productCategoryNextTokens: {
          ...state.productCategoryNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "LIST_PRODUCT_CATEGORIES_ERROR":
      return {
        ...state,
        request: null,
        productCategoriesLoading: false,
        productCategoriesError: action.error,
      };
    case "REQUEST_CREATE_PRODUCT_CATEGORY":
      return {
        ...state,
        newCategory: "",
        newCategoryError: null,
        newCategoryLoading: true,
      };
    case "SUCCESS_CREATE_PRODUCT_CATEGORY":
      return {
        ...state,
        newCategory: action.payload.category,
        productCategories: [
          ...state.productCategories,
          action.payload.category,
        ],
        newCategoryLoading: false,
      };
    case "ERROR_CREATE_PRODUCT_CATEGORY":
      return {
        ...state,
        newCategoryLoading: false,
        newCategoryError: action.error,
      };
    case "REQUEST_UPDATE_PRODUCT_CATEGORY":
      return {
        ...state,
        updateCategoryError: null,
        updateCategoryLoading: true,
      };
    case "SUCCESS_UPDATE_PRODUCT_CATEGORY":
      return {
        ...state,
        productCategories: state.productCategories.map((category) =>
          category.id === action.payload.category.id
            ? action.payload.category
            : category,
        ),
        updateCategoryLoading: false,
      };
    case "ERROR_UPDATE_PRODUCT_CATEGORY":
      return {
        ...state,
        updateCategoryLoading: false,
        updateCategoryError: action.error,
      };
    case "REQUEST_ADJUST_PRODUCT_STOCK":
      return {
        ...state,
        adjustStockLedger: {},
        adjustStockError: null,
        adjustStockLoading: true,
      };
    case "ADJUST_PRODUCT_STOCK_SUCCESS":
      const { ledger } = action.payload;
      const { productID, quantityAfter, createdAt } = ledger;

      // Update single businessProduct if it matches the productID
      const updatedBusinessProduct =
        state.businessProduct.id === productID
          ? {
              ...state.businessProduct,
              currentStock: quantityAfter,
              stockLastUpdatedAt: createdAt,
            }
          : state.businessProduct;

      // Update product in businessProducts array if it matches the productID
      const updatedBusinessProducts = state.businessProducts.map((item) =>
        item.id === productID
          ? {
              ...item,
              currentStock: quantityAfter,
              stockLastUpdatedAt: createdAt,
            }
          : item
      );

      return {
        ...state,
        adjustStockLedger: ledger,
        businessProduct: updatedBusinessProduct,
        businessProducts: updatedBusinessProducts,
        adjustStockLoading: false,
      };
    case "ADJUST_PRODUCT_STOCK_ERROR":
      return {
        ...state,
        adjustStockError: action.error,
        adjustStockLoading: false,
      };
    case "REQUEST_INVENTORY_WRITEDOWN":
      return {
        ...state,
        writeDownError: null,
        writeDownResult: null,
        writeDownLoading: true,
      };
    case "INVENTORY_WRITEDOWN_SUCCESS": {
      const { result } = action.payload;
      // No-op write-down (NRV >= average cost, or no stock): nothing to patch.
      if (!result || !result.writedownAmount) {
        return { ...state, writeDownResult: result, writeDownLoading: false };
      }
      const writeDownProduct =
        state.businessProduct.id === result.productID
          ? { ...state.businessProduct, averageCost: result.averageCost }
          : state.businessProduct;
      const writeDownProducts = state.businessProducts.map((item) =>
        item.id === result.productID
          ? { ...item, averageCost: result.averageCost }
          : item
      );
      return {
        ...state,
        businessProduct: writeDownProduct,
        businessProducts: writeDownProducts,
        writeDownResult: result,
        writeDownLoading: false,
      };
    }
    case "INVENTORY_WRITEDOWN_ERROR":
      return {
        ...state,
        writeDownError: action.error,
        writeDownLoading: false,
      };
    case "CLEAR_PRODUCT_CATEGORY":
      return {
        ...state,
        newCategory: "",
        newCategoryError: null,
      };
    case "CLEAR_BUSINESS_PRODUCT":
      return {
        ...state,
        newProduct: "",
        productID: "",
        businessProduct: {},
        deletedID: "",
      };
    case "CLEAR_ADJUST_PRODUCT_STOCK":
      return {
        ...state,
        adjustStockLedger: {},
        adjustStockError: null,
      };
    case "CLEAR_INVENTORY_WRITEDOWN":
      return {
        ...state,
        writeDownResult: null,
        writeDownError: null,
        writeDownLoading: false,
      };
    case "CLEAR_BUSINESS_PRODUCT_ERROR":
      return {
        ...state,
        newProductError: null,
        businessProductError: null,
        updateProductError: null,
        deleteProductError: null,
      };
    case "REQUEST_LIST_INVENTORY_LEDGER":
      return {
        ...state,
        request: action.payload.request,
        inventoryLedger: [],
        inventoryLedgerLoading: true,
        inventoryLedgerError: null,
        inventoryLedgerNextTokens:
          action.payload.page === 1
            ? initialState.inventoryLedgerNextTokens
            : state.inventoryLedgerNextTokens,
      };
    case "LIST_INVENTORY_LEDGER_SUCCESS":
      return {
        ...state,
        request: null,
        inventoryLedger: action.payload.items,
        inventoryLedgerLoading: false,
        inventoryLedgerNextTokens: {
          ...state.inventoryLedgerNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "LIST_INVENTORY_LEDGER_ERROR":
      return {
        ...state,
        request: null,
        inventoryLedgerLoading: false,
        inventoryLedgerError: action.error,
      };
    case "LIST_INVENTORY_LEDGER_CANCEL":
      return {
        ...state,
        request: null,
        inventoryLedgerLoading: false,
      };
    case "CLEAR_INVENTORY_LEDGER":
      return {
        ...state,
        inventoryLedger: [],
        inventoryLedgerError: null,
        inventoryLedgerNextTokens: initialState.inventoryLedgerNextTokens,
      };
    // A save abandoned mid-flight (its modal closed). Without a case here its
    // loading flag stayed on and the next open showed a spinning button.
    case "CANCEL_CREATE_BUSINESS_PRODUCT":
      return {
        ...state,
        request: null,
        newProductLoading: false,
      };
    case "CANCEL_UPDATE_BUSINESS_PRODUCT":
      return {
        ...state,
        request: null,
        updateProductLoading: false,
      };
    default:
      return state;
  }
};
